import { useSnapshot } from 'valtio';

import * as authStore from '@cartwhl/common/stores/authStore';
import Button from '@cartwhl/ui/input/Button';

import useAppletsUrl from '../hooks/useAppletsUrl';
import useHasHydrated from '../hooks/useHasHydrated';
import NavigationLink from './NavigationLink';

interface StartOrLaunchButtonProps {
  anonymousHref?: string;
  className?: string;
  hideWhenLoggedIn?: boolean;
}

export default function StartOrLaunchButton({
  anonymousHref = '/pricing',
  className,
  hideWhenLoggedIn = false,
}: StartOrLaunchButtonProps) {
  const { authStatus } = useSnapshot(authStore.state);
  const appletsUrl = useAppletsUrl();
  const hasHydrated = useHasHydrated();

  if (hasHydrated && authStatus === 'user') {
    if (hideWhenLoggedIn) return null;

    if (!appletsUrl) {
      return (
        <Button type="button" variant="cta" className={className} disabled>
          Launch Cartwheel
        </Button>
      );
    }

    return (
      <Button as="a" href={appletsUrl} variant="cta" className={className}>
        Launch Cartwheel
      </Button>
    );
  }

  return (
    <Button
      as={NavigationLink}
      href={anonymousHref}
      variant="cta"
      className={className}
    >
      Start free trial
    </Button>
  );
}
